<template>
  <v-app id="app" style="background-color: transparent; min-height: unset;">
    <link href='https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Material+Icons' rel=”stylesheet”>
    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">

    <RealShrineLayout />
    <!-- <Temp /> -->
  </v-app>
</template>

<script>
  import RealShrineLayout from './layouts/RealShrineLayout';
  // import Temp from './layouts/Temp';

  export default {
    name: 'app',
    components: {
      RealShrineLayout
      // Temp,
    },
    data: () => ({
    })
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue